import React, { useState } from 'react'

import { isNil } from 'lodash-es'
import styled from 'styled-components/native'

import { LoadingIndicator } from '../../atoms/icons/LoadingIndicator'
import {
  MessengerUtilityItem,
  MessengerUtilityItemProps,
} from '../../molecules/messengerUtilityItem/MessengerUtilityItem'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export type MessengerUtilityItemListProps = {
  items: MessengerUtilityItemProps[] | null
  useTokenTextInput?: boolean
  expandedContent?: (itemId: string) => React.ReactNode
  onItemExpand?: (itemId: string | null) => void
}

const ItemsContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  background: theme.colors.backgroundPrimary,
}))

export const MessengerUtilityItemList = ({
  items,
  useTokenTextInput,
  expandedContent,
  onItemExpand,
}: MessengerUtilityItemListProps) => {
  const [expandedItemId, setExpandedItemId] = useState<string | null>(null)

  const handleItemExpand = (itemId: string | null) => {
    setExpandedItemId(itemId)
    onItemExpand?.(itemId)
  }

  const handleItemPress = (item: MessengerUtilityItemProps) => {
    // Toggle expanded state - if clicking the same item, collapse it
    const newExpandedId = expandedItemId === item.id ? null : item.id
    handleItemExpand(newExpandedId)
    item.onPress?.()
  }
  return (
    <ItemsContainer testID={tID('MessengerUtilityItemList')}>
      {isNil(items) ? (
        <LoadingIndicator />
      ) : (
        <>
          {items.map((item, index) => {
            const isExpanded = expandedItemId === item.id
            return (
              <MessengerUtilityItem
                key={item.id}
                id={item.id}
                header={item.header}
                loading={item.loading}
                subheader={item.subheader}
                text={item.text}
                updateDate={item.updateDate}
                onDeletePress={item.onDeletePress}
                onEditPress={item.onEditPress}
                onPress={() => handleItemPress(item)}
                onSendPress={item.onSendPress}
                onOpenOriginalFormPress={item.onOpenOriginalFormPress}
                onToggleSwitch={item.onToggleSwitch}
                useHoverActionButtons={item.useHoverActionButtons}
                useToggleSwitch={item.useToggleSwitch}
                topBorder={index > 0}
                useTokenTextInput={useTokenTextInput}
                isExpanded={isExpanded}
                expandedContent={expandedContent ? expandedContent(item.id) : undefined}
              />
            )
          })}
        </>
      )}
    </ItemsContainer>
  )
}
